import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
const models = [{
  name: 'CJI',
  fullName: 'Civic Judgment Index',
  body: 'Supports structured reasoning and judgment assessment within HCF.',
  href: '/cji',
  linkLabel: 'Explore CJI'
}, {
  name: 'NCJI',
  fullName: 'Neurocognitive Civic Judgment Index',
  body: 'Uses the five-pillar working architecture for civic judgment and development, connecting findings with development pathways and reassessment across the lifecycle.',
  href: '/ncji',
  linkLabel: 'Explore NCJI'
}];
export function HumanCapabilityModels() {
  return <section id="cji-ncji" aria-labelledby="cji-ncji-title" className="scroll-mt-20 bg-white border-t border-line py-20 lg:py-24" data-id="element-1238" data-mp="21m8o0ekj2g6i">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1239" data-mp="29wdrej1bam3">
        <div className="lg:col-span-5" data-id="element-1240" data-mp="3f0c0s45ht1cp">
          <h2 id="cji-ncji-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-5" data-id="element-1241" data-mp="3f1dmr3o1r897">
            CJI and NCJI
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1242" data-mp="35b27ikywxcn0">
            HCF includes two assessment instruments. Both remain under
            development.
          </p>
        </div>
        <ul className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-x-10 border-t border-line" data-id="element-1243" data-mp="1ssdftbfnk8z">
          {models.map(model => <li key={model.name} className="flex flex-col pt-6 pb-2" data-id="element-1244" data-mp="3syk0gjtwygrk">
              <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-1245" data-mp="3owyjone9dic3">{model.name}</h3>
              <p className="text-sm font-medium text-teal mb-3" data-id="element-1246" data-mp="3jz6rds9pbu7d">{model.fullName}</p>
              <p className="text-lg text-ink-dark leading-relaxed mb-5" data-id="element-1247" data-mp="2dke7xdcw0fbg">{model.body}</p>
              <a href={model.href} className="mt-auto inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1248" data-mp="28k9yg7aeckuq">
                {model.linkLabel}
                <ArrowRight size={16} aria-hidden="true" data-id="element-1249" data-mp="252ccccxakvap" />
              </a>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}